import LegalPageLayout from "@/components/LegalPageLayout";

const SECTIONS = [
  {
    title: "Inledning",
    body: [
      "Den här integritetspolicyn beskriver hur Hundify behandlar personuppgifter när du använder vår webbplats eller vår tjänst som affärssystem för hundverksamheter. Vi värnar om din integritet och behandlar alla personuppgifter i enlighet med dataskyddsförordningen (GDPR) och annan tillämplig svensk lagstiftning.",
      "Genom att använda vår webbplats eller vår tjänst godkänner du den behandling av personuppgifter som beskrivs i denna policy. Om du inte godkänner villkoren ska du inte använda tjänsten.",
    ],
  },
  {
    title: "Personuppgifter vi samlar in",
    body: [
      "Vi samlar in personuppgifter i följande situationer:",
      [
        "När du fyller i ett formulär på vår webbplats (till exempel demo-ansökan eller kontaktförfrågan).",
        "När du skapar ett konto eller använder vår tjänst.",
        "När du kommunicerar med oss via e-post, chat eller telefon.",
        "Automatiskt när du besöker webbplatsen, via cookies och liknande teknik.",
      ],
      "De personuppgifter som behandlas kan inkludera namn, e-postadress, telefonnummer, företagsnamn, organisationsnummer, befattning, IP-adress, enhetsinformation samt information om hur du använder tjänsten.",
    ],
  },
  {
    title: "Ändamål med behandlingen",
    body: [
      "Vi behandlar dina personuppgifter för följande ändamål:",
      [
        "För att tillhandahålla, underhålla och förbättra tjänsten.",
        "För att kommunicera med dig om din användning av tjänsten.",
        "För att hantera kundsupport och svara på förfrågningar.",
        "För att skicka information om produktnyheter och relevant marknadsföring (endast efter samtycke eller där det finns ett berättigat intresse).",
        "För att uppfylla rättsliga skyldigheter, till exempel bokföring och redovisning.",
        "För att förebygga missbruk, bedrägerier och säkerhetsincidenter.",
      ],
    ],
  },
  {
    title: "Rättslig grund",
    body: [
      "Behandlingen av dina personuppgifter sker på följande rättsliga grunder:",
      [
        "Avtal — när behandlingen är nödvändig för att fullgöra avtalet med dig som kund.",
        "Berättigat intresse — för att förbättra tjänsten, förebygga missbruk och utveckla produkten.",
        "Samtycke — när du aktivt valt att ta emot till exempel nyhetsbrev eller liknande kommunikation.",
        "Rättslig förpliktelse — för att uppfylla lagstadgade krav, exempelvis enligt bokföringslagen.",
      ],
    ],
  },
  {
    title: "Lagring och säkerhet",
    body: [
      "Vi lagrar dina personuppgifter så länge det är nödvändigt för att uppfylla ändamålen i denna policy eller så länge som krävs enligt lag. När uppgifterna inte längre behövs raderas eller anonymiseras de.",
      "Personuppgifter lagras på servrar inom EU/EES. Vi använder branschstandard för kryptering och åtkomstkontroller för att skydda dina uppgifter mot obehörig åtkomst, ändring och förlust.",
    ],
  },
  {
    title: "Delning med tredje part",
    body: [
      "Vi säljer aldrig dina personuppgifter. Vi delar endast uppgifter med tredje part i följande situationer:",
      [
        "Med underleverantörer (personuppgiftsbiträden) som hjälper oss leverera tjänsten — till exempel hostingleverantörer, e-postutskick och betalningstjänster.",
        "När det krävs enligt lag, domstolsbeslut eller myndighetsbeslut.",
        "Vid en eventuell företagsöverlåtelse, fusion eller liknande transaktion, där förvärvande part övertar våra åtaganden.",
      ],
      "Vi tecknar personuppgiftsbiträdesavtal med samtliga underleverantörer som behandlar personuppgifter för vår räkning.",
    ],
  },
  {
    title: "Dina rättigheter",
    body: [
      "Du har följande rättigheter enligt GDPR:",
      [
        "Rätt till tillgång — du kan begära information om vilka personuppgifter vi behandlar om dig.",
        "Rätt till rättelse — du kan begära att felaktiga uppgifter rättas.",
        "Rätt till radering — under vissa förutsättningar kan du begära att vi raderar dina uppgifter.",
        "Rätt till begränsning — du kan begära att behandlingen begränsas.",
        "Rätt till dataportabilitet — du kan begära att få ut dina uppgifter i ett strukturerat och maskinläsbart format.",
        "Rätt att invända — mot behandling som sker med stöd av berättigat intresse.",
        "Rätt att återkalla samtycke — när behandlingen sker med stöd av samtycke.",
      ],
      "För att utöva någon av dessa rättigheter, kontakta oss via uppgifterna på vår kontaktsida.",
    ],
  },
  {
    title: "Cookies",
    body: [
      "Vi använder cookies och liknande tekniker för att leverera och förbättra tjänsten samt för att analysera trafiken på webbplatsen. Mer information om vår användning av cookies finns i vår separata cookie­policy.",
    ],
  },
  {
    title: "Klagomål till tillsynsmyndighet",
    body: [
      "Du har alltid rätt att lämna in ett klagomål till Integritetsskyddsmyndigheten (IMY) om du anser att vi behandlar dina personuppgifter i strid med gällande lagstiftning.",
    ],
  },
  {
    title: "Ändringar i policyn",
    body: [
      "Vi kan komma att uppdatera den här integritetspolicyn vid behov. Den senaste versionen finns alltid publicerad på vår webbplats med datumet för senaste uppdatering tydligt angivet. Vid väsentliga förändringar informerar vi våra kunder via e-post eller direkt i tjänsten.",
    ],
  },
];

export default function PrivacyPage() {
  return (
    <LegalPageLayout
      testid="page-privacy"
      category="Integritetspolicy"
      title="Integritetspolicy"
      lastUpdated="December 2026"
      sections={SECTIONS}
      seoDescription="Hundifys integritetspolicy beskriver hur vi behandlar personuppgifter enligt GDPR. Läs om vilka uppgifter vi samlar in, ändamål och dina rättigheter."
      seoPath="/integritetspolicy"
    />
  );
}
